import React from 'react'
import { ReactComponent as LogoULA } from '../../../assets/LogoULA.svg'

export default function Home() {
  return (
    <div
      className="h-screen flex flex-col w-full items-end justify-start lg:justify-center relative snap-start overflow-hidden"
      id="home"
    >
      <img
        src="/images/Rx.jpg"
        alt="Craneum rx"
        className="absolute max-xs:scale-[0.25] max-xxs:hidden -left-20 lg:-left-40 2xl:left-0 bottom-4 scale-50 lg:top-20 lg:bottom-auto lg:scale-100 xl:scale-200"
      />
      <div className="w-full lg:w-3/5 xl:w-2/5 p-8 lg:p-12 text-[#B1ECFD]">
        <LogoULA className="w-full lg:w-80 lg:absolute top-0 lg:mt-12 mt-10 right-36" />
        <header className="text-center max-xr:text-sm text-2xl lg:text-5xl xr:mt-8 mb-8 uppercase">
          Guía Cefalométrica
        </header>
        <p className="text-center lg:mr-8 text-sm sm:text-md tracking-tight lg:text-xl mb-8 max-xr:text-xs">
          La cefalometría es el registro e interpretación de las mediciones del
          cráneo realizadas en radiografías estandarizadas de la cabeza viva.
        </p>
        <p className="text-center lg:mr-8 text-sm sm:text-md tracking-tight lg:text-xl max-xr:text-xs">
          Es considerada como una herramienta muy importante para los
          ortodoncistas y cirujanos maxilofaciales dedicados al estudio de la
          cefalometría, maloclusiones y las discrepancias esqueléticas
          subyacentes.
        </p>
        <p className="xxs:w-2/5 w-full xxs:right-8 lg:right-24 xxs:absolute max-md:bottom-40 lg:bottom-12 max-xs:text-xs text-sm max-lg:mt-8 max-xxs:text-center text-left xl:text-right">
          <strong>Por:</strong> Josmar Muñoz, Jorge Rodriguez y Dunia Marquina{' '}
          <br />
          <strong>Tutores:</strong> Jormany Quintero y Carmine Lobo
        </p>
      </div>
    </div>
  )
}
